var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projectContainer",on:{"click":_vm.emitSelected}},[_c('div',{staticClass:"bkgImage",style:({ 'background-image': 'url(' + require(`/src/assets/photos/thumbnail/${_vm.project.path}`) + ')'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }